module.exports = __webpack_public_path__ + "static/media/21_tn.a2ee3574.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/21_tn.jpg
// module id = 330
// module chunks = 0